import { Component, Fragment } from 'react'
import Layout from '../components/share/Layout'

import {
  SettingService, HeaderService, SlideService, TinTucService, GalleryService
} from '../services'
import { tagContent } from "../util/jqueryUtil";

import { CONTENT } from '../const/content';
import ContentComponent from '../components/share/ContentComponent';
import TopSlide from '../components/index/TopSlide';
import HoatDongVuiHoc from '../components/index/HoatDongVuiHoc';
import Megastory from '../components/index/Megastory';
import TinTuyenSinh from '../components/index/TinTuyenSinh';
import { DANH_MUC } from '../const/danh-muc';
import SuKienTrongTuan from '../components/index/SuKienTrongTuan';
import FormDangKy from '../components/index/FormDangKy';
import Video from '../components/index/Video';
import CoSoVatChat from '../components/index/CoSoVatChat';
import { PageTransition } from "next-page-transitions";
import { SETTING } from '../const/setting';



export default class extends Component<any, any> {

  private searchText1: string = '';

  private searchText2: string = '';
  aos: any;
  page: number = 1
  per_page = 10
  count = 0;

  ten_danh_muc: string;
  constructor(props) {
    super(props)
    this.ten_danh_muc = '';
    this.state = {
      danhSachTinTuc: [],
      loading: false,
      test: '',
    }
  }


  static async getInitialProps() {
    const layoutProps = await Layout.getInitialProps();
    // const title = await SettingService.getSetting(SETTING.title_trang_chu);
    const header = await HeaderService.getsHeader([
      CONTENT.CONTENT_ROYAL_HOME_CHUONGTRINHHOC_VN,
      CONTENT.CONTENT_ROYAL_HOME_NOIVECHUNGTOI_VN,
      CONTENT.CONTENT_ROYAL_HOME_MAP_VN,

    ],
      [SETTING.royal_meta_tag_trang_chu_english]
    )
    const CONTENT_ROYAL_HOME_CHUONGTRINHHOC_VN = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_HOME_CHUONGTRINHHOC_VN);
    const CONTENT_ROYAL_HOME_NOIVECHUNGTOI_VN = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_HOME_NOIVECHUNGTOI_VN);
    const CONTENT_ROYAL_HOME_MAP_VN = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_HOME_MAP_VN);

    const slides = await SlideService.getsSlide();
    const title = await SettingService.getSetting(SETTING.royal_title_trang_chu_english);

    return {
      title: title.value.value,
      layoutProps,
      slides: slides,
      CONTENT_ROYAL_HOME_CHUONGTRINHHOC_VN: CONTENT_ROYAL_HOME_CHUONGTRINHHOC_VN.content,
      CONTENT_ROYAL_HOME_NOIVECHUNGTOI_VN: CONTENT_ROYAL_HOME_NOIVECHUNGTOI_VN.content,
      CONTENT_ROYAL_HOME_MAP_VN: CONTENT_ROYAL_HOME_MAP_VN.content,
    }
  }
  componentDidMount() {
    const fragment = window.location.hash.substr(1);
    const elementScrollTo = document.getElementById(fragment);
    if (elementScrollTo) {
      elementScrollTo.scrollIntoView();
    }
    tagContent();
  }

  render() {
    return (

      <Layout title={this.props.title} {...this.props.layoutProps}>
        {/* <PageTransition timeout={400} classNames="page-transition"> */}
          <Fragment >
            <TopSlide images={this.props.slides} />
            <Megastory />
            <HoatDongVuiHoc />
            <TinTuyenSinh />
            {/* <ContentComponent content={this.props.CONTENT_ROYAL_HOME_CHUONGTRINHHOC_VN} /> */}
            <SuKienTrongTuan />
            <CoSoVatChat />
            <div className="block back-noivechungtoi no-padding-top">
              <div className="w-full">
                <ContentComponent content={this.props.CONTENT_ROYAL_HOME_NOIVECHUNGTOI_VN} />
                <Video />
              </div>
            </div>
            <FormDangKy />
            <ContentComponent content={this.props.CONTENT_ROYAL_HOME_MAP_VN} />
          </Fragment>
        {/* </PageTransition> */}
        <style jsx global>
          {`
                .page-transition-enter {
                  opacity: 0;
                }
                .page-transition-enter-active {
                  opacity: 1;
                  transition: opacity ${400}ms;
                }
                .page-transition-exit {
                  opacity: 1;
                }
                .page-transition-exit-active {
                  opacity: 0;
                  transition: opacity ${400}ms;
                }
              `}
        </style>
      </Layout>
    )
  }
}

